import { pick, keys, merge, snakeCase, isPlainObject } from 'lodash';

export type ModelLike = {
  [key: string]: any
}

export class JsonApiPayload {
  id: string;

  static new(model: ModelLike) {
  }

  static fill<T>(instance: T, object: any) {
    object = object || {};
    const props = pick(object, keys(instance));
    merge(instance, props);
    return instance;
  }

  static _getSchema<T>(ctor: ClassConstructor<T>, relationshipsKeys: StringKeys<T>[]) {
    const payload = fillProps(new ctor());
    const attributes = convertCase(payload, relationshipsKeys);
    const relationshipsRawKeys = relationshipsKeys.map(key => snakeCase(key));
    const relationshipsEntries = relationshipsRawKeys.map(key => [
      key,
      { jsonApi: key.endsWith('s') ? 'hasMany' : 'hasOne', type: key }
    ]);
    const relationships = Object.fromEntries(relationshipsEntries) as Relationships;

    const schema = { ...attributes, ...relationships };
    return schema;
  }

  static _getRaw<T>(instance: T) {
    const raw = convertCase(instance, []);
    return raw;
  }
}

type StringKeys<T> = string & keyof T;

type Relationships = {
  [key: string]: {
    jsonApi: 'hasMany' | 'hasOne',
    type: string,
  }
}

type ClassConstructor<T = any> = {
  new (...args: any[]): T;
};

function fillProps(object: any) {
  const keys = Object.entries(object);
  const rawEntries = keys.map(([key, value]) => {
    const rawValue = isPlainObject(value) ? value : null;
    return [key, rawValue];
  });
  const raw = Object.fromEntries(rawEntries);
  return raw;
}

function convertCase(object: any, excludedKeys: string[]) {
  const keys = Object.entries(object);
  const rawEntries = keys.map<[string, any]>(([key, value]) => {
    const rawKey = snakeCase(key).replace(/_(\d)/, '$1');
    const rawValue = isPlainObject(value) ? convertCase(value, []) : value;
    const entry = [rawKey, rawValue] as [string, any];
    return entry;
  });
  const filteredEntries = rawEntries.filter(item => !excludedKeys.includes(item[0]));
  const raw = Object.fromEntries(filteredEntries);
  return raw;
}
